import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { TRANSLATION_A11Y_SHELL_OPEN_CONTENT } from '@wdx/shared/utils';

@Component({
    selector: 'wdx-app-shell',
    templateUrl: './wdx-app-shell.component.html',
    styleUrls: ['./wdx-app-shell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxAppShellComponent {
    private offcanvasService = inject(NgbOffcanvas);

    readonly A11Y_SHELL_OPEN_CONTENT = TRANSLATION_A11Y_SHELL_OPEN_CONTENT;

    open(content: any) {
        this.offcanvasService.open(content, { panelClass: 'offcanvas-sm' });
    }
}
